module.exports = __webpack_public_path__ + "static/media/baleine-big.6e36689d.png";